var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-3"},[_c('v-spacer'),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Кузя")]),_vm._v(" © 2020 ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }